/* OEMUPGRADES: vehicle finder, option pre-selection, price breakdown.
   Theme-agnostic: works with any OS 2.0 product form that has input[name="id"]. */
(function () {
  'use strict';
  if (window.__oemLoaded) return;
  window.__oemLoaded = true;

  var KEY = 'oem_vehicle_v1';
  var GOALS = {
    carplay: 'Apple CarPlay & Android Auto',
    wireless: 'Wireless CarPlay & Android Auto',
    nav: 'Built-in navigation (works without phone signal)',
    bigger: 'Bigger screen',
    cluster: 'Digital instrument cluster',
    fix: 'Fix a dead or broken screen'
  };
  var SYSTEMS = {
    radio: 'no SYNC screen',
    sync1: '4.2" SYNC 1',
    sync2: '8" MyFord Touch (SYNC 2)',
    sync3: '8" SYNC 3',
    sync4: '8" SYNC 4',
    unsure: 'an unknown or aftermarket radio'
  };
  // Result groups, in the order shown for "See every upgrade for my vehicle"
  var KITS = [
    { k: 'sync1-to-sync3', sys: 'sync1', head: 'Have the small 4.2" SYNC 1 display?', sub: '4" to 8" SYNC 3 conversion: touchscreen, Apple CarPlay & Android Auto' },
    { k: 'sync2-to-sync3', sys: 'sync2', head: 'Have the 8" MyFord Touch (SYNC 2)?', sub: 'SYNC 2 to SYNC 3 upgrade: Apple CarPlay & Android Auto, faster screen' },
    { k: 'apim', sys: 'sync3', head: 'Already have SYNC 3?', sub: 'Add CarPlay, navigation or wireless CarPlay (USB adapter), or replace a failed module' },
    { k: 'sync3-12in-screen', sys: null, head: 'Want a bigger 12" screen?', sub: '12" Sharp touchscreen running SYNC 3. Works with trucks that have no SYNC, SYNC 1, SYNC 2 or SYNC 3' },
    { k: 'sync3-to-sync4', sys: 'sync3', head: 'Have SYNC 3? Step up to SYNC 4', sub: 'SYNC 4 with factory wireless CarPlay & Android Auto, big-screen options for trucks' },
    { k: 'sync4-screen', sys: 'sync4', head: 'Have the 8" SYNC 4?', sub: 'Upgrade to the 12" SYNC 4 screen' },
    { k: 'cluster', sys: null, head: 'Digital instrument cluster', sub: 'Replace analog gauges with a factory-style LCD cluster' }
  ];

  /* ---------- storage ---------- */
  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function save(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ }
    document.dispatchEvent(new CustomEvent('oem:vehicle', { detail: v }));
  }
  window.OEM = { load: load, save: save, GOALS: GOALS, SYSTEMS: SYSTEMS };

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = (cents || 0) / 100;
    return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: n % 1 ? 2 : 0 });
  }
  function norm(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function optNames(p) {
    return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }
  function role(name) {
    var n = String(name).toLowerCase();
    if (n.indexOf('factory system') > -1) return 'factory';
    if (n.indexOf('wireless') > -1) return 'wireless';
    if (n.indexOf('navigation') > -1 || n.indexOf('navi') > -1) return 'nav';
    if (n.indexOf('model') > -1) return 'model';
    if (n.indexOf('generation') > -1) return 'gen';
    if (n.indexOf('apim') > -1 && n.indexOf('original') > -1) return 'hasapim';
    return 'other';
  }
  function isNo(v) { return /^\s*(no|non)\b/i.test(v); }
  function yearsIn(v) {
    var m = String(v).match(/(20\d\d)\s*[-–]\s*(20\d\d)/);
    if (m) return [+m[1], +m[2]];
    m = String(v).match(/(20\d\d)/);
    return m ? [+m[1], +m[1]] : null;
  }
  function modelMatches(value, vehicle) {
    if (!vehicle || !vehicle.model) return false;
    var nv = norm(value), nm = norm(vehicle.model);
    if (nv.indexOf(nm) === -1) return false;
    var yr = yearsIn(value);
    return !yr || !vehicle.year || (vehicle.year >= yr[0] && vehicle.year <= yr[1]);
  }

  /* Choose the option values that match the vehicle + goals. Returns {values:[], notes:[]} */
  function desiredValues(p, vehicle, goals) {
    var names = optNames(p), values = [], notes = [];
    goals = goals || [];
    names.forEach(function (name, i) {
      var vals = uniq(p.variants.map(function (v) { return v.options[i]; }));
      var r = role(name), pick = null;
      if (r === 'nav') {
        var want = goals.indexOf('nav') > -1;
        pick = want ? first(vals, function (v) { return !isNo(v) && !/no apim/i.test(v); }) : first(vals, isNo);
        if (want && pick) notes.push('built-in navigation');
      } else if (r === 'wireless') {
        var w = goals.indexOf('wireless') > -1;
        pick = w ? first(vals, function (v) { return !isNo(v); }) : first(vals, isNo);
        if (w && pick) notes.push('wireless CarPlay');
      } else if (r === 'model') {
        pick = first(vals, function (v) { return modelMatches(v, vehicle); });
        if (pick) notes.push(pick);
      } else if (r === 'gen' && vehicle && vehicle.year) {
        pick = first(vals, function (v) { return vehicle.year >= 2019 ? /gen\s*4/i.test(v) : /gen\s*3/i.test(v); });
      } else if (r === 'factory' && vehicle && vehicle.system) {
        var FS = { radio: /no sync/i, sync1: /sync\s*1/i, sync2: /sync\s*2/i, sync3: /sync\s*3/i };
        if (FS[vehicle.system]) pick = first(vals, function (v) { return FS[vehicle.system].test(v); });
      } else if (r === 'hasapim') {
        pick = first(vals, function (v) { return /^yes/i.test(v); });
      }
      values.push(pick);
    });
    return { values: values, notes: notes };
  }
  function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function first(a, fn) { for (var i = 0; i < a.length; i++) if (fn(a[i])) return a[i]; return null; }

  function bestVariant(p, values) {
    var cands = p.variants.filter(function (v) {
      return values.every(function (val, i) { return val == null || v.options[i] === val; });
    });
    return first(cands, function (v) { return v.available; }) || cands[0] || null;
  }

  /* Price of the same configuration with paid add-ons switched off */
  function breakdown(p, variant) {
    var names = optNames(p), lines = [], baseVals = variant.options.slice();
    names.forEach(function (name, i) {
      var r = role(name);
      if (r === 'nav' || r === 'wireless') {
        var noVal = first(uniq(p.variants.map(function (v) { return v.options[i]; })), isNo);
        if (noVal) baseVals[i] = noVal;
      }
    });
    var base = bestVariant(p, baseVals) || variant;
    var running = base.price;
    names.forEach(function (name, i) {
      var r = role(name);
      if ((r === 'nav' || r === 'wireless') && !isNo(variant.options[i])) {
        var v2 = baseVals.slice(); v2[i] = variant.options[i];
        var with1 = bestVariant(p, v2);
        var delta = with1 ? with1.price - base.price : null;
        lines.push({ label: r === 'nav' ? 'Built-in navigation' : 'Wireless CarPlay & Android Auto (USB adapter)', delta: delta });
        if (delta) running += delta;
      }
    });
    return { base: base.price, lines: lines, total: variant.price, compare: variant.compare_at_price };
  }

  /* All add-on prices for the "Options" list */
  function addonPrices(p, variant) {
    var names = optNames(p), out = [];
    names.forEach(function (name, i) {
      var r = role(name);
      if (r !== 'nav' && r !== 'wireless') return;
      var vals = uniq(p.variants.map(function (v) { return v.options[i]; }));
      var noVal = first(vals, isNo), yesVal = first(vals, function (v) { return !isNo(v) && !/no apim/i.test(v); });
      if (!noVal || !yesVal) return;
      var a = variant.options.slice(); a[i] = noVal;
      var b = variant.options.slice(); b[i] = yesVal;
      var va = bestVariant(p, a), vb = bestVariant(p, b);
      out.push({
        label: r === 'nav' ? 'Built-in Ford navigation with North America maps (works without phone signal)' : 'Wireless CarPlay & Android Auto: plug-in USB wireless adapter',
        delta: va && vb ? vb.price - va.price : null
      });
    });
    return out;
  }

  /* ---------- product page ---------- */
  function productPage() {
    var box = document.querySelector('[data-oem-buybox]');
    var dataEl = document.querySelector('script[data-oem-product]');
    if (!box || !dataEl) return;
    var p;
    try { p = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = findForm(box);

    // VIN goes into the product form as a line item property
    var vin = document.querySelector('[data-oem-vin]');
    if (vin && form) {
      // note: form.id would return the <input name="id">, so use attributes
      var fid = form.getAttribute('id');
      if (!fid) { fid = 'oem-product-form'; form.setAttribute('id', fid); }
      vin.setAttribute('form', fid);
      vin.addEventListener('input', function () { vin.value = vin.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 17); });
    }

    // Option labels like "Yes + $100" are based on list prices; hide the "+ $100" part
    // (the real add-on price is shown in the price breakdown).
    var section = box.closest('.shopify-section') || document.body;
    var PRICE_RX = /\s*\+\s*\$\s?\d[\d,]*(?:\.\d+)?/g;
    function cleanLabels() {
      var nodes = section.querySelectorAll('fieldset label, fieldset legend, select option, .variant-option__button-label__text, [class*="variant"] label');
      Array.prototype.forEach.call(nodes, function (n) {
        var walker = document.createTreeWalker(n, NodeFilter.SHOW_TEXT, null);
        var t;
        while ((t = walker.nextNode())) {
          if (PRICE_RX.test(t.nodeValue)) { PRICE_RX.lastIndex = 0; t.nodeValue = t.nodeValue.replace(PRICE_RX, ''); }
          PRICE_RX.lastIndex = 0;
        }
      });
    }
    cleanLabels();
    try { new MutationObserver(function () { cleanLabels(); }).observe(section, { childList: true, subtree: true }); } catch (e) {}

    var totalEl = document.querySelector('[data-oem-total]');
    var optsEl = document.querySelector('[data-oem-options]');
    var last = null;
    function render() {
      var idEl = form && form.querySelector('[name="id"]');
      var id = idEl ? Number(idEl.value) : (p.variants[0] && p.variants[0].id);
      if (id === last) return;
      last = id;
      var v = first(p.variants, function (x) { return x.id === id; });
      if (!v) return;
      var b = breakdown(p, v);
      if (totalEl) {
        var h = '<div class="oem-total__row"><span>Kit for your vehicle</span><span>' + money(b.base) + '</span></div>';
        b.lines.forEach(function (l) {
          h += '<div class="oem-total__row"><span>+ ' + esc(l.label) + '</span><span>' + (l.delta != null ? money(l.delta) : 'included') + '</span></div>';
        });
        h += '<div class="oem-total__row"><span>Shipping to the US</span><span>Free</span></div>';
        h += '<div class="oem-total__row"><span>Import duties</span><span>None</span></div>';
        var rate = Number(box.getAttribute('data-oem-dealer-rate') || 0);
        if (rate > 0) {
          // same rounding as the checkout discount: percentage of the line, rounded half up to the cent
          var off = Math.floor((b.total * rate + 50) / 100);
          h += '<div class="oem-total__row"><span>Subtotal</span><span>' + money(b.total) + '</span></div>';
          h += '<div class="oem-total__row oem-total__row--dealer"><span>Dealer discount (' + rate + '%)</span><span>−' + money(off) + '</span></div>';
          h += '<div class="oem-total__row oem-total__row--sum"><span>Your dealer price</span><span>' + money(b.total - off) + '</span></div>';
          h += '<p class="oem-total__save">Applied automatically at checkout while you are logged in.</p>';
        } else {
          h += '<div class="oem-total__row oem-total__row--sum"><span>You pay</span><span>' + money(b.total) + '</span></div>';
          if (b.compare && b.compare > b.total) h += '<p class="oem-total__save">You save ' + money(b.compare - b.total) + ' off the list price</p>';
        }
        totalEl.innerHTML = h;
        totalEl.hidden = false;
      }
      if (optsEl) {
        var a = addonPrices(p, v);
        optsEl.innerHTML = a.length ? a.map(function (o) {
          return '<li>' + esc(o.label) + (o.delta != null ? ' <strong>+' + money(o.delta) + '</strong>' : '') + '</li>';
        }).join('') : '<li class="oem-muted">No paid options for this kit.</li>';
      }
    }
    render();
    setInterval(render, 400);
    document.addEventListener('change', function () { setTimeout(render, 50); });

    // Pre-select options from the saved vehicle + goals (never overrides a ?variant= link)
    var veh = load();
    var hasVariantParam = /[?&]variant=/.test(location.search);
    if (veh && !hasVariantParam && fitsVehicle(p, veh)) {
      var d = desiredValues(p, veh, veh.goals);
      var target = bestVariant(p, d.values);
      var idEl = form && form.querySelector('[name="id"]');
      if (target && idEl && Number(idEl.value) !== target.id) {
        applyVariant(form, p, target).then(function (ok) {
          if (!ok) {
            var u = new URL(location.href);
            u.searchParams.set('variant', target.id);
            location.replace(u.toString());
          }
        });
      }
      var pre = box.querySelector('[data-oem-preselect]');
      if (pre && d.notes.length) {
        pre.innerHTML = 'Pre-selected for your ' + esc(veh.year + ' ' + veh.model) + ': ' + esc(d.notes.join(', ')) + '. <button type="button" class="oem-linkbtn" data-oem-clear>Change vehicle</button>';
        pre.hidden = false;
      }
    }
  }

  function findForm(box) {
    var scope = box.closest('.shopify-section') || document;
    var f = scope.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]') ||
      scope.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('main form[action*="/cart/add"]');
    return f;
  }

  function fitsVehicle(p, veh) {
    var tags = p.tags || [];
    var m = norm(veh.model);
    var modelOk = tags.some(function (t) { return t.indexOf('Model_') === 0 && norm(t.slice(6)) === m.replace('EXPEDITION', 'EXPIDITION'); });
    var years = tags.filter(function (t) { return t.indexOf('Year_') === 0; });
    var yearOk = !years.length || years.indexOf('Year_' + veh.year) > -1;
    return modelOk && yearOk;
  }

  // Click the theme's own option inputs so the theme updates price, media and the hidden id.
  function applyVariant(form, p, target) {
    var root = form.closest('.shopify-section, section, main') || document;
    var names = optNames(p);
    var i = 0;
    return new Promise(function (resolve) {
      function step() {
        if (i >= names.length) {
          setTimeout(function () {
            var idEl = form.querySelector('[name="id"]');
            resolve(idEl && Number(idEl.value) === target.id);
          }, 700);
          return;
        }
        var val = target.options[i];
        var oname = names[i];
        i++;
        var ofName = function (x) { return x.name && (x.name.indexOf(oname) === 0 || x.name === 'options[' + oname + ']'); };
        var inputs = Array.prototype.slice.call(root.querySelectorAll('input[type="radio"]'));
        var r = first(inputs, function (x) { return x.value === val && ofName(x); });
        if (r && !r.checked) { r.click(); return setTimeout(step, 650); }
        var sels = Array.prototype.slice.call(root.querySelectorAll('select'));
        var s = first(sels, function (x) { return ofName(x) && Array.prototype.some.call(x.options, function (o) { return o.value === val; }); });
        if (s && s.value !== val) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); return setTimeout(step, 650); }
        step();
      }
      step();
    });
  }

  /* ---------- vehicle finder ---------- */
  function finder(root) {
    var data;
    try { data = JSON.parse(root.querySelector('script[data-oem-finder-data]').textContent); } catch (e) { return; }
    var state = load() || {};
    var el = function (s) { return root.querySelector(s); };
    var makeSel = el('[data-f-make]'), modelSel = el('[data-f-model]'), yearSel = el('[data-f-year]');
    var results = el('[data-f-results]');
    var allBtn = el('[data-f-all]');

    var models = {};
    data.products.forEach(function (p) {
      p.ms.forEach(function (m) {
        var mk = /^(MK|Navigator)/.test(m) ? 'Lincoln' : 'Ford';
        models[mk] = models[mk] || {};
        models[mk][m] = models[mk][m] || {};
        (p.ys.length ? p.ys : []).forEach(function (y) { models[mk][m][y] = 1; });
      });
    });

    function fillModels() {
      var mk = makeSel.value;
      var list = Object.keys(models[mk] || {}).sort();
      modelSel.innerHTML = '<option value="">Choose model</option>' + list.map(function (m) { return '<option>' + esc(m) + '</option>'; }).join('');
      if (state.make === mk && list.indexOf(state.model) > -1) modelSel.value = state.model;
      fillYears();
    }
    function fillYears() {
      var mk = makeSel.value, m = modelSel.value;
      var ys = m ? Object.keys((models[mk] || {})[m] || {}).map(Number).sort(function (a, b) { return b - a; }) : [];
      yearSel.innerHTML = '<option value="">Choose year</option>' + ys.map(function (y) { return '<option>' + y + '</option>'; }).join('');
      if (state.model === m && ys.indexOf(Number(state.year)) > -1) yearSel.value = String(state.year);
      syncAll();
    }
    function syncAll() {
      if (!allBtn) return;
      var ok = modelSel.value && yearSel.value;
      allBtn.disabled = !ok;
      allBtn.textContent = ok ? 'See every upgrade for my ' + yearSel.value + ' ' + modelSel.value : 'See every upgrade for my vehicle';
    }
    makeSel.addEventListener('change', fillModels);
    modelSel.addEventListener('change', fillYears);
    yearSel.addEventListener('change', syncAll);
    if (state.make) makeSel.value = state.make;
    fillModels();

    // restore screen + goals
    if (state.system) { var r = root.querySelector('input[name="oem-system"][value="' + state.system + '"]'); if (r) r.checked = true; }
    (state.goals || []).forEach(function (g) { var c = root.querySelector('input[name="oem-goal"][value="' + g + '"]'); if (c) c.checked = true; });

    function vehicleFromForm() {
      return { make: makeSel.value, model: modelSel.value, year: Number(yearSel.value) || null };
    }
    function run(v) {
      save(v);
      state = v;
      show(v);
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (allBtn) allBtn.addEventListener('click', function () {
      var v = vehicleFromForm();
      if (!v.model || !v.year) return;
      v.system = null; v.goals = []; v.all = true;
      run(v);
    });

    root.querySelector('[data-f-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = vehicleFromForm();
      var sys = root.querySelector('input[name="oem-system"]:checked');
      v.system = sys ? sys.value : null;
      v.goals = Array.prototype.map.call(root.querySelectorAll('input[name="oem-goal"]:checked'), function (c) { return c.value; });
      if (!v.model || !v.year) { results.innerHTML = '<p class="oem-warn">Choose your model and year first.</p>'; results.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      v.all = !v.system;  // no screen picked: show everything for the vehicle
      run(v);
    });

    function fits(p, v) {
      var sysOk = !p.fs || !p.fs.length || !v.system || p.fs.indexOf(v.system) > -1;
      return !p.hide && sysOk && p.ms.indexOf(v.model) > -1 && (!p.ys.length || p.ys.indexOf(v.year) > -1);
    }

    // One product per kit type: the vehicle-specific listing first (better match for the customer and for ads),
    // unless it lacks an option the customer asked for; then in stock, then most reviews.
    function pickOne(list, v) {
      var need = (v.goals || []).filter(function (g) { return g === 'wireless' || g === 'nav'; });
      function score(p) {
        var s = 0;
        if (need.every(function (g) { return p.opts.indexOf(g) > -1; })) s += 1000;
        if ((v.goals || []).indexOf('bigger') > -1 && /15\.5|12\s*(''|"|inch|in\b)/i.test(p.t)) s += 1000;
        if (p.av !== false) s += 500;
        s += Math.max(0, 100 - p.ms.length * 10);          // fewer models = more specific
        s += Math.min(p.rc || 0, 99) / 100;
        return s;
      }
      return list.slice().sort(function (a, b) { return score(b) - score(a); })[0] || null;
    }

    function kitsFor(v) {
      var g = v.goals || [], k = [];
      var none = !g.length;
      var big = none || g.indexOf('bigger') > -1;
      switch (v.system) {
        case 'radio': if (big) k.push('sync3-12in-screen'); break;
        case 'sync1': k.push('sync1-to-sync3'); if (big) k.push('sync3-12in-screen'); break;
        case 'sync2': k.push('sync2-to-sync3'); if (big) k.push('sync3-12in-screen'); break;
        case 'sync3':
          if (big) k.push('sync3-12in-screen');
          if (big) k.push('sync3-to-sync4');
          if (none || g.some(function (x) { return x !== 'bigger' && x !== 'cluster'; })) k.unshift('apim');
          break;
        case 'sync4':
          if (none || g.indexOf('bigger') > -1 || g.indexOf('fix') > -1) k.push('sync4-screen');
          break;
      }
      var asked = v.system === 'radio' || v.system === 'unsure';
      if (g.indexOf('cluster') > -1 || (none && !asked)) k.push('cluster');
      return k;
    }

    function coverage(kit, goal, p) {
      // returns [state, text]; state: in | opt | have | no | na
      var hasOpt = function (r) { return p.opts.indexOf(r) > -1; };
      if (kit === 'cluster') return goal === 'cluster' ? ['in', 'Included'] : (goal === 'fix' ? ['in', 'Replaces the gauges'] : ['na', 'Separate upgrade']);
      if (kit === 'dongle') return goal === 'wireless' ? ['in', 'USB wireless adapter'] : ['na', '—'];
      if (kit === 'sync3-12in-screen') return ({ carplay: ['in', 'Included (wired)'], wireless: ['opt', 'Add our USB wireless adapter'], nav: ['na', 'Ask us'], bigger: ['in', '12" Sharp screen'], fix: ['in', 'Replaces screen'], cluster: ['na', 'See cluster upgrade'] })[goal] || ['na', ''];
      switch (goal) {
        case 'carplay':
          if (kit === 'sync4-screen') return ['have', 'Built in (SYNC 4)'];
          if (kit === 'sync3-to-sync4') return ['in', 'Included, wireless'];
          if (kit === 'apim') return ['in', 'Included (with a supported USB hub)'];
          return ['in', 'Included (wired)'];
        case 'wireless':
          if (kit === 'sync4-screen' || kit === 'sync3-to-sync4') return ['in', 'Built in (factory SYNC 4)'];
          return hasOpt('wireless') ? ['opt', 'Option: USB wireless adapter'] : ['opt', 'Add our USB wireless adapter'];
        case 'nav':
          if (kit === 'sync3-to-sync4') return ['opt', 'Needs factory navigation'];
          return hasOpt('nav') ? ['opt', 'Option'] : ['no', 'Not with this kit'];
        case 'bigger':
          if (kit === 'sync4-screen') return ['in', 'Included'];
          if (kit === 'sync3-to-sync4') return /15\.5|12\s*(''|"|inch|in\b)/i.test(p.t) ? ['in', 'Included'] : ['no', 'Same 8" size'];
          if (kit === 'sync1-to-sync3') return ['in', '4.2" to 8" touchscreen'];
          return ['no', 'Screen stays 8"'];
        case 'cluster':
          return ['na', 'See cluster upgrade'];
        case 'fix':
          if (kit === 'sync4-screen' || kit === 'sync3-to-sync4') return ['in', 'Replaces screen'];
          return ['in', 'Replaces module' + (kit === 'apim' ? '' : ' and screen')];
      }
      return ['no', ''];
    }

    function helpBox(title, text, btn) {
      return '<div class="oem-res-help"><h3>' + title + '</h3><p>' + text + '</p><p><a class="oem-btn" href="' + esc(data.contact) + '">' + (btn || 'Ask us') + '</a></p></div>';
    }

    function card(p, v, kit) {
      var c = document.createElement('article');
      c.className = 'oem-res';
      var goals = v.goals && v.goals.length ? v.goals : [];
      var cov = goals.map(function (g) {
        var x = coverage(kit, g, p);
        return '<li class="oem-cov oem-cov--' + x[0] + '"><span>' + esc(GOALS[g]) + '</span><em>' + esc(x[1]) + '</em></li>';
      }).join('');
      c.innerHTML = (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="300" height="300">' : '') +
        '<div class="oem-res__body"><h4>' + esc(p.t) + '</h4>' +
        (p.rc >= 3 ? '<p class="oem-res__stars">★ ' + Number(p.r).toFixed(1) + ' · ' + p.rc + ' reviews</p>' : '') +
        (cov ? '<ul class="oem-res__cov">' + cov + '</ul>' : '') +
        '<p class="oem-res__price" data-price>' + (p.av === false ? 'Ask us about availability · ' : '') + 'From ' + money(p.p) + '</p>' +
        '<a class="oem-btn" data-link href="' + esc(p.u) + '">See this kit</a></div>';
      if (goals.length && kit !== 'dongle') {
        // exact total for the chosen goals, and a link with those options pre-selected
        fetch(p.u.split('?')[0] + '.js').then(function (r) { return r.json(); }).then(function (full) {
          var d = desiredValues(full, v, goals);
          var tv = bestVariant(full, d.values);
          if (!tv) return;
          c.querySelector('[data-price]').innerHTML = 'Your total <strong>' + money(tv.price) + '</strong> · free US shipping, no duties';
          var a = c.querySelector('[data-link]');
          a.href = p.u.split('?')[0] + '?variant=' + tv.id;
          a.textContent = 'See this kit (options pre-selected)';
        }).catch(function () {});
      }
      return c;
    }

    function show(v) {
      var veh = esc(v.year + ' ' + v.model);
      var goals = v.goals || [];
      var groups = [];
      KITS.forEach(function (K) {
        var list = data.products.filter(function (p) { return p.k === K.k && fits(p, v); });
        var best = pickOne(list, v);
        groups.push({ K: K, best: best });
      });
      function group(k) { return first(groups, function (g) { return g.K.k === k; }); }

      // ---- "See every upgrade for my vehicle": one product per upgrade type, labelled by screen ----
      if (v.all) {
        var shown = groups.filter(function (g) { return g.best; });
        results.innerHTML = '<h3 class="oem-res-title">Upgrades for your ' + veh + '</h3>' +
          '<p class="oem-sub">Each upgrade depends on the screen in your dash now. Not sure which one you have? Compare the photos above, or send us a photo of your dash.</p>' +
          '<div class="oem-res-groups"></div>';
        var wrap = results.querySelector('.oem-res-groups');
        if (!shown.length) {
          wrap.innerHTML = helpBox('No ready-made kit listed for a ' + veh, 'Send us your VIN. Many vehicles can still be upgraded with a custom kit.');
          return;
        }
        shown.forEach(function (g) {
          var sec = document.createElement('section');
          sec.className = 'oem-res-group';
          sec.innerHTML = '<h4 class="oem-res-group__head">' + esc(g.K.head) + '</h4><p class="oem-res-group__sub">' + esc(g.K.sub) + '</p><div class="oem-res-grid"></div>';
          var grid = sec.querySelector('.oem-res-grid');
          grid.appendChild(card(g.best, v, g.K.k));
          if (g.K.k === 'apim' && data.dongle) grid.appendChild(card(data.dongle, v, 'dongle'));
          wrap.appendChild(sec);
        });
        wrap.insertAdjacentHTML('beforeend', helpBox('Not sure which one fits?', 'Send us your VIN and a photo of your dash. We reply with the exact kit and total price before you pay anything.', 'Send VIN + photo'));
        return;
      }

      // ---- screen picked ----
      var out = [];
      var kits = kitsFor(v);
      kits.forEach(function (k) {
        var g = group(k);
        if (g && g.best) out.push(g);
      });
      var hasKit = out.some(function (x) { return x.K && x.K.k !== 'cluster'; });
      if (v.system === 'unsure' || (v.system === 'radio' && !hasKit)) {
        out.unshift(helpBox('Let us check your ' + veh + ' first',
          (v.system === 'radio' ? 'A dash without a SYNC screen needs extra parts and wiring, so we confirm the kit for your exact truck. ' : 'An aftermarket radio, or not sure what you have? ') +
          'Send us your VIN and a photo of your dash. We reply with the exact kit and total price before you pay anything.', 'Send VIN + photo'));
      } else if (v.system === 'radio') {
        out.unshift('<p class="oem-sub">No SYNC screen? The kit below adds one, with everything needed to fit your dash. Want us to double-check first? <a href="' + esc(data.contact) + '">Send us your VIN</a>.</p>');
      }
      var addDongle = v.system === 'sync3' && goals.indexOf('wireless') > -1 && data.dongle;
      var cards = out.filter(function (x) { return x.K; });
      if (!cards.length && !addDongle) {
        if (v.system !== 'radio' && v.system !== 'unsure') {
          var msg = v.system === 'sync4' && goals.indexOf('bigger') === -1 && goals.indexOf('fix') === -1
            ? 'SYNC 4 already has wireless CarPlay and Android Auto built in. Want the bigger 12" screen? Tick "Bigger screen" above.'
            : 'Send us your VIN. Many vehicles can still be upgraded with a custom kit.';
          results.innerHTML = helpBox('No ready-made kit listed for a ' + veh + ' with ' + esc(SYSTEMS[v.system] || 'this screen'), msg);
        } else {
          results.innerHTML = out.join('');
        }
        return;
      }
      // One recommendation: the kit that covers most of what the customer asked for.
      // A digital cluster is a separate upgrade, so it is shown next to it, not as an alternative.
      var cands = cards.filter(function (g) { return g.K.k !== 'cluster'; }).map(function (g) { return { p: g.best, kit: g.K.k }; });
      if (addDongle) cands.push({ p: data.dongle, kit: 'dongle' });
      var order = KITS.map(function (K) { return K.k; }).concat(['dongle']);
      function rank(c) {
        var full = 0, inc = 0;
        goals.forEach(function (g) {
          if (g === 'cluster') return;
          var st = coverage(c.kit, g, c.p)[0];
          if (st === 'in' || st === 'have') { inc++; full++; } else if (st === 'opt') { full++; }
        });
        return full * 100 + inc * 10 - order.indexOf(c.kit) / 10;
      }
      cands.sort(function (a, b) { return rank(b) - rank(a); });
      var best = cands.slice(0, 1), more = cands.slice(1);
      var clusterG = first(cards, function (g) { return g.K.k === 'cluster'; });
      var main = best.concat(clusterG ? [{ p: clusterG.best, kit: 'cluster' }] : []);
      var sysTxt = v.system && SYSTEMS[v.system] && v.system !== 'radio' && v.system !== 'unsure' ? ' with ' + esc(SYSTEMS[v.system]) : '';
      results.innerHTML = out.filter(function (x) { return typeof x === 'string'; }).join('') +
        '<h3 class="oem-res-title">' + (best.length ? 'Best match' : 'Recommended') + ' for your ' + veh + sysTxt + '</h3><div class="oem-res-grid" data-main></div>' +
        (more.length ? '<details class="oem-res-more"><summary>Other options (' + more.length + ')</summary><div class="oem-res-grid" data-more></div></details>' : '');
      var gm = results.querySelector('[data-main]'), gx = results.querySelector('[data-more]');
      main.forEach(function (c) { gm.appendChild(card(c.p, v, c.kit)); });
      more.forEach(function (c) { gx.appendChild(card(c.p, v, c.kit)); });
    }
    if (state.model && state.year && (state.system || state.all)) show(state);
  }

  /* ---------- vehicle bar ---------- */
  function vehicleBar() {
    var bars = document.querySelectorAll('[data-oem-vbar]');
    if (!bars.length) return;
    function paint() {
      var v = load();
      Array.prototype.forEach.call(bars, function (b) {
        var label = b.querySelector('[data-vbar-label]');
        if (v && v.model && v.year) {
          label.textContent = v.year + ' ' + v.model + (v.system && SYSTEMS[v.system] ? ' · ' + SYSTEMS[v.system] : '');
          b.classList.add('oem-vbar--set');
        } else {
          label.textContent = b.getAttribute('data-empty') || 'Select your vehicle';
          b.classList.remove('oem-vbar--set');
        }
      });
    }
    paint();
    document.addEventListener('oem:vehicle', paint);
  }

  /* ---------- lite YouTube ---------- */
  function videos() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-oem-yt]');
      if (!b) return;
      var id = b.getAttribute('data-oem-yt');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true;
      f.title = b.getAttribute('aria-label') || 'Video';
      b.replaceWith(f);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-oem-clear]')) {
        try { localStorage.removeItem(KEY); } catch (x) {}
        location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '#oem-finder';
      }
    });
  }

  function init() {
    productPage();
    Array.prototype.forEach.call(document.querySelectorAll('[data-oem-finder]'), finder);
    vehicleBar();
    videos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
